<template>
  <div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-8">
          <div class="form-group">
            <label for="instalacion">Instalación</label>
            <v-select
              class="form-control form-control-sm p-0"
              v-model="instalacion"
              :options="listasForms.instalaciones"
              placeholder="Seleccione instalación..."
              label="descripcion"
              :class="$v.form.instalacion.$invalid ? 'is-invalid' : 'is-valid'"
              @input="selectInstalacion()"
              multiple
            ></v-select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="consecutivo_carga">Consecutivo de Carga</label>
            <input
              type="number"
              class="form-control form-control-sm"
              id="consecutivo_carga"
              v-model="form.consecutivo_carga"
              :class="
                $v.form.consecutivo_carga.$invalid ? 'is-invalid' : 'is-valid'
              "
            />
          </div>
        </div>
        <div class="col-md-2 align-self-center mt-2">
          <button
            type="button"
            @click="save()"
            class="btn btn-primary"
            v-show="
              !$v.form.$invalid &&
                $store.getters.can('argentina.clientes.agregarCorreo')
            "
          >
            <i class="fa fa-plus-circle"></i> Agregar
          </button>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-12">
          <table
            id="docs"
            class="table table-bordered table-striped table-hover table-sm table-head-fixed text-nowrap"
          >
            <thead class="text-center align-middle">
              <tr>
                <th>Instalación</th>
                <th>Consecutivo de Carga</th>
                <th>Consecutivo Actual</th>
                <!-- <th>Opciones</th> -->
              </tr>
            </thead>
            <tbody class="text-center align-middle">
              <tr
                v-for="(data, index) in $parent.form.cliente_instalaciones"
                :key="index"
              >
                <td>{{ data.descripcion }}</td>
                <td>{{ data.pivot.consecutivo_carga }}</td>
                <td v-if="data.pivot.consecutivo_actual">
                  {{ data.pivot.consecutivo_actual }}
                </td>
                <td v-else>
                  <span class="badge badge-warning"
                    >Sin creación de hojas de carga</span
                  >
                </td>
                <!-- <td>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"                                        
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
export default {
  name: "ClienteConsecutivoCarga",
  components: {
    vSelect,
  },
  data() {
    return {
      form: {
        instalacion: [],
        consecutivo_carga: null,
        consecutivo_actual: null,
      },
      listasForms: {
        instalaciones: [],
      },
      instalacion: [],
      cargas: [],
    };
  },
  validations: {
    form: {
      instalacion: {
        required,
      },
      consecutivo_carga: {
        required,
      },
    },
  },

  methods: {
    getInstalaciones() {
      axios.get("/api/lista/231").then((response) => {
        this.listasForms.instalaciones = response.data;
      });
    },

    selectInstalacion() {
      this.form.instalacion = [];
      if (this.instalacion) {
        this.form.instalacion = this.instalacion.map((i) => i.numeracion);
      }
    },

    save() {
      this.form.cliente_id = this.$parent.form.id;
      if (!this.$v.form.$invalid) {
        const existentes = this.$parent.form.cliente_instalaciones || [];
        const duplicadas = this.instalacion.filter((inst) =>
          existentes.some((e) => e.numeracion === inst.numeracion),
        );

        if (duplicadas.length > 0) {
          const nombres = duplicadas.map((d) => d.descripcion).join(", ");
          this.$swal({
            icon: "warning",
            title: "Instalación(es) duplicada(s)",
            text: `Las siguientes instalaciones ya están asignadas: ${nombres}`,
            showConfirmButton: true,
          });
          return;
        }

        axios({
          method: "PUT",
          url: "/api/argentina/clientes/saveConsecutivoCarga",
          data: this.form,
        })
          .then((response) => {
            this.limpiarFormulario();
            this.$parent.form.cliente_instalaciones =
              response.data.cliente_instalaciones;
            this.$swal({
              icon: "success",
              title: "El consecutivo de carga se guardo exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    limpiarFormulario() {
      this.form = {
        instalacion: [],
        consecutivo_carga: null,
      };
      this.instalacion = [];
    },
  },

  created() {
    this.getInstalaciones();
  },
};
</script>
